import { useState } from 'react';

export default function HomePage() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const testimonials = [
    {
      name: "Beatriz Aparecida Moreira",
      role: "Empresária - Curitiba",
      text: "A Ana é uma profissional super dedicada e responsável. Sou muito grata pela eficiência em conseguir resolver todas as questões burocráticas com eficiência.",
      service: "Regularização Empresarial"
    },
    {
      name: "Wellington Johann",
      role: "Empreendedor - Curitiba",
      text: "Atendimento humano faz toda a diferença. Rodei por algumas opções que só tinha chatbot atendendo. Responde rapidamente e faz questão de explicar tudo muito bem. Super agilizada e eficiente.",
      service: "Consultoria Contábil"
    },
    {
      name: "Ariane Cordeiro",
      role: "Empresária - Curitiba",
      text: "Quero agradecer a Ana pelo ótimo trabalho que vem fazendo na contabilidade da minha empresa. Gosto muito da agilidade e clareza nas informações. Está sendo essencial para organizar a parte financeira da empresa. Obrigada mesmo!",
      service: "BPO Financeiro"
    }
  ];

  const whatsappUrl = "https://api.whatsapp.com/send/?phone=554185113433&text=Olá%2C+Ana%21+Vi+seu+site+e+gostaria+de+saber+mais+sobre+abertura+de+empresa+em+Curitiba.+Pode+me+ajudar%3F&app_absent=0";

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const handleWhatsAppClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = e.currentTarget.href;

    // Dispara o evento de conversão no Google Ads
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-17673482447/ByHZCJbS6rMbEM_hr-tB',
        value: 1.0,
        currency: 'BRL',
      });
    }

    // Abre o WhatsApp em nova aba independentemente do gtag
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center flex-shrink-0">
              <div className="flex items-center space-x-2">
                <img 
                  src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/b65bab23ffbc8fdf41293e6a9fbe878f.png" 
                  alt="Ana Fortes Contabilidade" 
                  className="h-8 sm:h-10 w-auto"
                />
              </div>
            </div>
            
            <nav className="hidden md:flex items-center space-x-4 lg:space-x-8">
              <button onClick={() => scrollToSection('inicio')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base">
                Início
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base">
                Como funciona
              </button>
              <button onClick={() => scrollToSection('planos')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base">
                Planos
              </button>
              <button onClick={() => scrollToSection('depoimentos')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base">
                Depoimentos
              </button>
              <button onClick={() => scrollToSection('contato')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer text-sm lg:text-base">
                Contato
              </button>
            </nav>
            
            <div className="hidden lg:flex items-center space-x-4 xl:space-x-6">
              <div className="flex items-center space-x-2 text-xs xl:text-sm text-gray-600">
                <i className="ri-phone-line text-blue-600"></i>
                <span className="hidden xl:inline">(41) 98511-3433</span>
              </div>
              <div className="flex items-center space-x-2 text-xs xl:text-sm text-gray-600">
                <i className="ri-mail-line text-blue-600"></i>
                <span className="hidden xl:inline">ana@contadoraemcuritiba.com.br</span>
              </div>
              <a 
                href={whatsappUrl} 
                onClick={handleWhatsAppClick}
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-green-500 hover:bg-green-600 text-white px-3 xl:px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-whatsapp-line mr-1 xl:mr-2"></i>WhatsApp
              </a>
            </div>
            
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 cursor-pointer"
            >
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-2 space-y-2">
              <button onClick={() => scrollToSection('inicio')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg">
                Início
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg">
                Como funciona
              </button>
              <button onClick={() => scrollToSection('planos')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg">
                Planos
              </button>
              <button onClick={() => scrollToSection('depoimentos')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg">
                Depoimentos
              </button>
              <button onClick={() => scrollToSection('contato')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg">
                Contato
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/e90b8e3d1931f55407130a3d3782d34a.jpg')`
        }}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-gray-800/70 to-slate-900/80"></div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-12 sm:py-16">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="space-y-6 sm:space-y-8 text-center lg:text-left">
              <div className="space-y-4 sm:space-y-6">
                <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight">
                  Abertura de empresa em Curitiba com suporte contábil completo
                </h1>
                <p className="text-base sm:text-lg lg:text-xl text-blue-100 leading-relaxed">
                  Abrimos seu CNPJ com orientação tributária, documentação completa e acompanhamento desde o início.
                </p>
                <ul className="space-y-2 sm:space-y-3 inline-block text-left">
                  <li className="flex items-start text-white text-sm sm:text-base">
                    <span className="text-blue-300 mr-3 mt-1">•</span>
                    <span>MEI, ME e LTDA</span>
                  </li>
                  <li className="flex items-start text-white text-sm sm:text-base">
                    <span className="text-blue-300 mr-3 mt-1">•</span>
                    <span>Junta Comercial e inscrições</span>
                  </li>
                  <li className="flex items-start text-white text-sm sm:text-base">
                    <span className="text-blue-300 mr-3 mt-1">•</span>
                    <span>Definição do regime tributário</span>
                  </li>
                  <li className="flex items-start text-white text-sm sm:text-base">
                    <span className="text-blue-300 mr-3 mt-1">•</span>
                    <span>Orientação para iniciar as operações</span>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl text-sm sm:text-base"
                >
                  <i className="ri-whatsapp-line mr-2 text-lg sm:text-xl"></i>Falar no WhatsApp
                </a>
              </div>
              <p className="text-xs sm:text-sm text-blue-100">
                Atendimento em Curitiba e Região Metropolitana
              </p>
            </div>
            <div className="relative hidden lg:block">
              <div className="relative z-10">
                <img 
                  alt="Ana Fortes Contabilidade" 
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover" 
                  src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/ca785a176c61b1e5a41bd567d6164029.jpeg"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-blue-400/30 rounded-full backdrop-blur-sm"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-indigo-400/30 rounded-full backdrop-blur-sm"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicos" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-xs sm:text-sm font-medium mb-4 sm:mb-6">
              <i className="ri-service-line mr-2"></i>Nossos Serviços
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
              Serviços para abrir seu CNPJ
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Oferecemos todos os serviços necessários para abrir sua empresa em Curitiba, desde a viabilidade até o registro completo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Abertura de Empresa ME/LTDA */}
            <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 border border-blue-200 ring-2 ring-blue-100">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-blue-600 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-medium">Em Alta</span>
              </div>
              <div className="space-y-4 sm:space-y-6">
                <div className="space-y-3 sm:space-y-4">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-xl flex items-center justify-center">
                    <i className="ri-building-line text-blue-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Abertura de empresa (ME/LTDA)</h3>
                    <p className="text-sm sm:text-base text-gray-600">Viabilidade, contrato social, registros e inscrições completas.</p>
                  </div>
                </div>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Consulta de viabilidade</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Contrato social</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Registro na Junta Comercial</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Inscrições municipais e estaduais</span>
                  </li>
                </ul>
                <div className="pt-4 border-t border-gray-100">
                  <p className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Valores sob consulta</p>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-full inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap bg-blue-600 text-white hover:bg-blue-700 text-sm sm:text-base"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>Solicitar proposta
                  </a>
                </div>
              </div>
            </div>

            {/* Abertura de MEI */}
            <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 border border-gray-100">
              <div className="space-y-4 sm:space-y-6">
                <div className="space-y-3 sm:space-y-4">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-xl flex items-center justify-center">
                    <i className="ri-user-add-line text-blue-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Abertura de MEI</h3>
                    <p className="text-sm sm:text-base text-gray-600">Abertura, orientação inicial e acompanhamento das obrigações.</p>
                  </div>
                </div>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Abertura completa do MEI</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Orientação sobre atividades e limites</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Declaração anual DASN-SIMEI</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Suporte para obrigações mensais</span>
                  </li>
                </ul>
                <div className="pt-4 border-t border-gray-100">
                  <p className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Valores sob consulta</p>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-full inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap bg-gray-100 text-gray-900 hover:bg-gray-200 text-sm sm:text-base"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>Solicitar proposta
                  </a>
                </div>
              </div>
            </div>

            {/* Contabilidade pós-abertura */}
            <div className="relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 border border-gray-100">
              <div className="space-y-4 sm:space-y-6">
                <div className="space-y-3 sm:space-y-4">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-xl flex items-center justify-center">
                    <i className="ri-calculator-line text-blue-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Contabilidade pós-abertura</h3>
                    <p className="text-sm sm:text-base text-gray-600">Mensalidades, rotina fiscal e obrigações contábeis.</p>
                  </div>
                </div>
                <ul className="space-y-2 sm:space-y-3">
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Escrituração contábil</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Declarações obrigatórias</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Apuração de impostos</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-check-line text-green-500 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-xs sm:text-sm">Consultoria tributária</span>
                  </li>
                </ul>
                <div className="pt-4 border-t border-gray-100">
                  <p className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Valores sob consulta</p>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-full inline-flex items-center justify-center px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap bg-gray-100 text-gray-900 hover:bg-gray-200 text-sm sm:text-base"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>Solicitar proposta
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Como Funciona Section */}
      <section id="como-funciona" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">Como funciona a abertura do seu CNPJ</h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Processo simples e transparente em 3 passos
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-search-line text-blue-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Passo 1: Diagnóstico e viabilidade</h3>
                <p className="text-sm sm:text-base text-gray-600">Análise da atividade, definição do CNAE correto e melhor enquadramento tributário para o seu negócio.</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-file-text-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Passo 2: Documentos e registros</h3>
                <p className="text-sm sm:text-base text-gray-600">Elaboração do contrato social, registro na Junta Comercial e inscrições na Receita Federal.</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-purple-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Passo 3: Empresa pronta para operar</h3>
                <p className="text-sm sm:text-base text-gray-600">Inscrições municipais e estaduais finalizadas, orientações iniciais e próximos passos para começar a faturar.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Diagnóstico Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="space-y-6 sm:space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Análise do tipo de empresa mais adequado</h3>
                  <p className="text-sm sm:text-base text-gray-600">Orientação sobre MEI, ME ou LTDA conforme sua atividade e faturamento.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Orientação sobre regime tributário</h3>
                  <p className="text-sm sm:text-base text-gray-600">Definição do melhor regime: Simples Nacional, Lucro Presumido ou Lucro Real.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Checklist do que será necessário</h3>
                  <p className="text-sm sm:text-base text-gray-600">Lista completa de documentos e informações para agilizar o processo de abertura.</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl">
              <div className="text-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                  <i className="ri-whatsapp-line text-green-600 text-xl sm:text-2xl"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">Solicite um diagnóstico para abertura</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
                  Converse com a Ana e descubra qual o melhor caminho para abrir sua empresa em Curitiba.
                </p>
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 w-full justify-center text-sm sm:text-base"
                >
                  <i className="ri-whatsapp-line text-base sm:text-lg"></i>Falar com a Ana
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre a Ana Fortes Section */}
      <section id="sobre" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="space-y-6 sm:space-y-8 order-2 lg:order-1 text-center lg:text-left">
              <div className="space-y-4 sm:space-y-6">
                <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-xs sm:text-sm font-medium">
                  <i className="ri-user-star-line mr-2"></i>Sobre a Ana Fortes
                </div>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight">
                  Sua contadora de<span className="text-blue-600 block">confiança</span>
                </h2>
                <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
                  Contadora especializada em abertura de empresas e atendimento a MEI e pequenas empresas em Curitiba e região. Com experiência sólida, ajudo empreendedores a iniciarem seus negócios de forma correta e segura.
                </p>
              </div>
              <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
                <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-2 lg:space-y-0 lg:space-x-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-blue-600 text-lg sm:text-xl"></i>
                  </div>
                  <div className="text-center lg:text-left">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">CRC ativo</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Registro profissional ativo no Conselho Regional de Contabilidade</p>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-2 lg:space-y-0 lg:space-x-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-briefcase-line text-green-600 text-lg sm:text-xl"></i>
                  </div>
                  <div className="text-center lg:text-left">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Experiência</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Especialização em abertura de empresas e MEI</p>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-2 lg:space-y-0 lg:space-x-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-purple-600 text-lg sm:text-xl"></i>
                  </div>
                  <div className="text-center lg:text-left">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Foco em pequenas empresas</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Atendimento especializado para quem está começando</p>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-2 lg:space-y-0 lg:space-x-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-orange-600 text-lg sm:text-xl"></i>
                  </div>
                  <div className="text-center lg:text-left">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Curitiba e região</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Atendimento em Curitiba e Região Metropolitana</p>
                  </div>
                </div>
              </div>
              <div className="pt-4">
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl text-sm sm:text-base"
                >
                  <i className="ri-chat-3-line mr-2"></i>Falar com a Ana
                </a>
              </div>
            </div>
            <div className="relative order-1 lg:order-2">
              <div className="relative z-10">
                <img 
                  alt="Ana Fortes - Contadora Especialista em Abertura de Empresas" 
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover" 
                  src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/ca785a176c61b1e5a41bd567d6164029.jpeg"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 w-20 h-20 sm:w-24 sm:h-24 bg-blue-400/20 rounded-full backdrop-blur-sm"></div>
              <div className="absolute -top-6 -right-6 w-24 h-24 sm:w-32 sm:h-32 bg-purple-400/20 rounded-full backdrop-blur-sm"></div>
              <div className="absolute -bottom-6 sm:-bottom-8 -right-6 sm:-right-8 bg-white rounded-xl shadow-xl p-4 sm:p-6 max-w-[200px] sm:max-w-xs">
                <div className="flex items-center space-x-2 sm:space-x-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-600 text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-xs sm:text-base">100% Digital</p>
                    <p className="text-xs sm:text-sm text-gray-600">Processos otimizados</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Planos Section */}
      <section id="planos" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">Planos de contabilidade após a abertura</h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Escolha o plano ideal para o seu momento empresarial
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Para MEI */}
            <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:scale-105">
              <div className="relative h-40 sm:h-48 overflow-hidden">
                <img 
                  alt="Para MEI" 
                  className="w-full h-full object-cover object-top" 
                  src="https://public.readdy.ai/ai/img_res/435e9ee47f165ec0c43aefe30cfea26b.jpg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg sm:text-xl font-bold">Para MEI</h3>
                  <p className="text-xs sm:text-sm opacity-90">Microempreendedor Individual</p>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                  Soluções completas para quem está começando ou já é MEI.
                </p>
                <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Declaração anual DASN-SIMEI
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Controle de faturamento mensal
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Orientação sobre limites e obrigações
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Suporte para crescimento
                  </li>
                </ul>
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-full text-center py-2 sm:py-3 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap block border border-gray-800 text-gray-800 hover:bg-gray-50 text-sm sm:text-base"
                >
                  Solicitar Proposta
                </a>
              </div>
            </div>

            {/* Para Microempresas */}
            <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:scale-105 ring-2 ring-gray-800">
              <div className="absolute top-4 right-4 bg-gray-800 text-white px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold z-10">
                Mais Popular
              </div>
              <div className="relative h-40 sm:h-48 overflow-hidden">
                <img 
                  alt="Para Microempresas" 
                  className="w-full h-full object-cover object-top" 
                  src="https://readdy.ai/api/search-image?query=Small%20business%20team%20working%20in%20modern%20office%2C%20professional%20workspace%20with%20computers%20and%20documents%2C%20collaborative%20environment%2C%20bright%20natural%20lighting%2C%20business%20growth%20concept&width=400&height=300&seq=sol2&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg sm:text-xl font-bold">Para Microempresas</h3>
                  <p className="text-xs sm:text-sm opacity-90">Simples Nacional</p>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                  Gestão completa para empresas que faturam até R$ 4,8 milhões.
                </p>
                <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Contabilidade completa
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Folha de pagamento
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Declarações obrigatórias
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Consultoria tributária
                  </li>
                </ul>
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-full text-center py-2 sm:py-3 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap block bg-gray-800 hover:bg-gray-900 text-white text-sm sm:text-base"
                >
                  Solicitar Proposta
                </a>
              </div>
            </div>

            {/* Para Pequenas Empresas */}
            <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:scale-105">
              <div className="relative h-40 sm:h-48 overflow-hidden">
                <img 
                  alt="Para Pequenas Empresas" 
                  className="w-full h-full object-cover object-top" 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20in%20modern%20conference%20room%2C%20executives%20discussing%20financial%20reports%2C%20corporate%20environment%2C%20strategic%20planning%20session%2C%20professional%20lighting&width=400&height=300&seq=sol3&orientation=landscape"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-lg sm:text-xl font-bold">Para Pequenas Empresas</h3>
                  <p className="text-xs sm:text-sm opacity-90">Lucro Presumido/Real</p>
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                  Soluções estratégicas para empresas em crescimento.
                </p>
                <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Planejamento tributário
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Análise de viabilidade
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Gestão financeira avançada
                  </li>
                  <li className="flex items-center text-xs sm:text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2 sm:mr-3 text-sm sm:text-base flex-shrink-0"></i>Consultoria estratégica
                  </li>
                </ul>
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-full text-center py-2 sm:py-3 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap block border border-gray-800 text-gray-800 hover:bg-gray-50 text-sm sm:text-base"
                >
                  Solicitar Proposta
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 sm:mt-16">
            <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-center">Pronto para abrir seu CNPJ em Curitiba?</h3>
              <p className="text-sm sm:text-base text-gray-300 mb-4 sm:mb-6 max-w-2xl mx-auto text-center">
                Entre em contato e receba uma avaliação gratuita. Vamos encontrar a melhor solução para o seu negócio.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white px-6 sm:px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
                >
                  <i className="ri-whatsapp-line mr-2"></i>Fale no WhatsApp
                </a>
                <div className="text-gray-300 text-xs sm:text-sm text-center">
                  <i className="ri-map-pin-line mr-1"></i>Atendimento em Curitiba e Região Metropolitana
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="depoimentos" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">O que dizem nossos clientes</h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Depoimentos reais de empreendedores que transformaram sua gestão contábil conosco.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12 relative">
              <div className="absolute top-6 left-6 w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 rounded-full flex items-center justify-center">
                <i className="ri-double-quotes-l text-gray-800 text-lg sm:text-xl"></i>
              </div>
              <div className="pt-8">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 sm:mb-6">
                    <h4 className="font-bold text-gray-900 text-lg sm:text-xl mb-1">{testimonials[currentTestimonial].name}</h4>
                    <p className="text-gray-600 text-xs sm:text-sm mb-3">{testimonials[currentTestimonial].role}</p>
                    <div className="flex justify-center space-x-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
                      ))}
                    </div>
                    <span className="inline-block bg-gray-100 text-gray-800 text-xs px-3 py-1 rounded-full">
                      {testimonials[currentTestimonial].service}
                    </span>
                  </div>
                  <div className="max-w-3xl">
                    <blockquote className="text-base sm:text-lg lg:text-xl text-gray-700 leading-relaxed italic">
                      "{testimonials[currentTestimonial].text}"
                    </blockquote>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-6 sm:mt-8 pt-6 border-t border-gray-200">
                <button 
                  onClick={prevTestimonial}
                  className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-gray-600"></i>
                </button>
                <div className="flex space-x-2">
                  {testimonials.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentTestimonial(index)}
                      className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-colors cursor-pointer ${
                        currentTestimonial === index ? 'bg-gray-800' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
                <button 
                  onClick={nextTestimonial}
                  className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-gray-600"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`bg-white rounded-xl p-4 sm:p-6 shadow-lg transition-all duration-300 cursor-pointer ${
                  currentTestimonial === index ? 'ring-2 ring-gray-800 transform scale-105' : 'hover:shadow-xl'
                }`}
              >
                <div className="text-center mb-3 sm:mb-4">
                  <h5 className="font-bold text-gray-900 text-sm sm:text-base mb-1">{testimonial.name}</h5>
                  <p className="text-gray-600 mb-2 sm:mb-3 text-xs sm:text-sm">{testimonial.role}</p>
                </div>
                <div className="flex justify-center space-x-1 mb-3 sm:mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xs sm:text-sm"></i>
                  ))}
                </div>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed line-clamp-4 text-center mb-2 sm:mb-3">
                  "{testimonial.text}"
                </p>
                <div className="text-center">
                  <span className="inline-block bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded-full">
                    {testimonial.service}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12 sm:mt-16">
            <div className="bg-gray-800 rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Quer ser o próximo a ter resultados assim?</h3>
              <p className="text-sm sm:text-base text-gray-300 mb-4 sm:mb-6 max-w-2xl mx-auto">
                Junte-se aos nossos clientes satisfeitos e tenha uma contabilidade que realmente funciona para o seu negócio.
              </p>
              <a 
                href={whatsappUrl} 
                onClick={handleWhatsAppClick}
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center bg-white text-gray-800 hover:bg-gray-100 px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2"></i>Solicitar uma proposta personalizada
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Números Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 px-4">Números que comprovam nossa excelência</h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              Resultados que demonstram nosso compromisso com o sucesso dos nossos clientes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center bg-white rounded-xl p-4 sm:p-6 shadow-lg">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-building-line text-blue-600 text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">98%</h4>
              <p className="text-sm sm:text-base text-gray-600 font-medium">Taxa de Aprovação</p>
              <p className="text-xs sm:text-sm text-gray-500 mt-1">Em aberturas de empresas</p>
            </div>

            <div className="text-center bg-white rounded-xl p-4 sm:p-6 shadow-lg">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-customer-service-line text-green-600 text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Rápido</h4>
              <p className="text-sm sm:text-base text-gray-600 font-medium">Atendimento</p>
              <p className="text-xs sm:text-sm text-gray-500 mt-1">Resposta ágil no WhatsApp</p>
            </div>

            <div className="text-center bg-white rounded-xl p-4 sm:p-6 shadow-lg flex flex-col justify-center">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Fale com a contadora e comece sua abertura</h3>
              <p className="text-gray-600 mb-3 sm:mb-4 text-xs sm:text-sm">
                Junte-se aos empreendedores que já abriram suas empresas com a Ana Fortes
              </p>
              <a 
                href={whatsappUrl} 
                onClick={handleWhatsAppClick}
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 text-xs sm:text-sm"
              >
                <i className="ri-whatsapp-line text-base sm:text-lg"></i>Falar com a Ana
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contato" className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-12 sm:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1 text-center sm:text-left">
              <div className="flex items-center space-x-2 mb-4 sm:mb-6 justify-center sm:justify-start">
                <img 
                  src="https://static.readdy.ai/image/7eb8c72f48167d9625e185e03fc12d5b/bf817876b8311f8ff357e13dc34ba1ee.png" 
                  alt="Ana Fortes Contabilidade" 
                  className="h-10 sm:h-12 w-auto"
                />
              </div>
              <p className="text-sm sm:text-base text-gray-300 mb-4 sm:mb-6 leading-relaxed">
                Especialista em abertura de empresas para MEI e pequenas empresas em Curitiba. Ajudando empreendedores a iniciarem seus negócios de forma correta e segura.
              </p>
              <div className="flex space-x-4 justify-center sm:justify-start">
                <a 
                  href={whatsappUrl} 
                  onClick={handleWhatsAppClick}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-white"></i>
                </a>
                <a 
                  href="https://www.instagram.com/anafortes.contadora" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 bg-pink-500 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-white"></i>
                </a>
                <a 
                  href="mailto:ana@contadoraemcuritiba.com.br" 
                  className="w-10 h-10 bg-gray-600 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-white"></i>
                </a>
              </div>
            </div>

            <div className="text-center sm:text-left">
              <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Nossos Serviços</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Abertura de MEI
                  </a>
                </li>
                <li>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Abertura de Empresas
                  </a>
                </li>
                <li>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Contabilidade Mensal
                  </a>
                </li>
                <li>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    Consultoria Tributária
                  </a>
                </li>
              </ul>
            </div>

            <div className="text-center sm:text-left">
              <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Links Rápidos</h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <button onClick={() => scrollToSection('inicio')} className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                    Início
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('como-funciona')} className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                    Como funciona
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('planos')} className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                    Planos
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('depoimentos')} className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                    Depoimentos
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('contato')} className="text-sm sm:text-base text-gray-300 hover:text-white transition-colors cursor-pointer">
                    Contato
                  </button>
                </li>
              </ul>
            </div>

            <div className="text-center sm:text-left">
              <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Contato</h4>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start space-x-3 justify-center sm:justify-start">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-blue-400"></i>
                  </div>
                  <div>
                    <p className="text-xs sm:text-sm text-gray-300">Curitiba e Região Metropolitana de Curitiba</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3 justify-center sm:justify-start">
                  <i className="ri-phone-line text-gray-400 flex-shrink-0"></i>
                  <a 
                    href="tel:+5541985113433" 
                    className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    (41) 98511-3433
                  </a>
                </div>

                <div className="flex items-center space-x-3 justify-center sm:justify-start">
                  <i className="ri-whatsapp-line text-gray-400 flex-shrink-0"></i>
                  <a 
                    href={whatsappUrl} 
                    onClick={handleWhatsAppClick}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    (41) 98511-3433
                  </a>
                </div>

                <div className="flex items-start space-x-3 justify-center sm:justify-start">
                  <i className="ri-mail-line text-gray-400 flex-shrink-0 mt-0.5"></i>
                  <a 
                    href="mailto:ana@contadoraemcuritiba.com.br" 
                    className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors cursor-pointer break-all"
                  >
                    ana@contadoraemcuritiba.com.br
                  </a>
                </div>
              </div>

              <div className="mt-4 sm:mt-6 bg-gray-800 rounded-lg p-3 sm:p-4">
                <h5 className="text-sm sm:text-base font-semibold mb-2 sm:mb-3 flex items-center justify-center sm:justify-start">
                  <i className="ri-time-line text-gray-400 mr-2"></i>Horário de Atendimento
                </h5>
                <div className="space-y-1 text-xs sm:text-sm text-gray-300">
                  <p>Segunda a Sexta: 8h às 18h</p>
                  <p>Sábado e Domingo: Plantão</p>
                </div>
                <p className="text-xs text-gray-400 mt-2">WhatsApp disponível 24h para urgências</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 py-6 sm:py-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">© 2025 Ana Fortes Contabilidade. Todos os direitos reservados.</p>
              <div className="flex items-center gap-2 text-xs sm:text-sm">
                <a 
                  href="https://readdy.ai/?ref=logo" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Floating WhatsApp Button */}
        <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
          <a 
            href={whatsappUrl} 
            onClick={handleWhatsAppClick}
            target="_blank" 
            rel="noopener noreferrer" 
            className="bg-green-500 hover:bg-green-600 text-white w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer animate-pulse"
          >
            <i className="ri-whatsapp-line text-xl sm:text-2xl"></i>
          </a>
        </div>
      </footer>
    </div>
  );
}
